import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Model from '../../model';

const Private = () => {
    const { isAuthenticated } = Model.user;

    return isAuthenticated ? <Outlet /> : <Navigate to='/' replace />;
};

export default Private;
